// --- Homepage carousel ---
const items = document.querySelectorAll('.carousel-item');

if (items.length) {
    const dots = document.querySelectorAll('.dot');
    const texts = document.querySelectorAll('.description-text');
    let currentIndex = 0;
    let autoRotateTimer;

    function rotate(targetIndex) {
        currentIndex = targetIndex;
        dots.forEach((dot, i) => dot.classList.toggle('active', i === targetIndex));
        texts.forEach((text, i) => text.classList.toggle('active', i === targetIndex));
        items.forEach((item, i) => {
            let newPos = i - targetIndex;
            if (newPos === 2) newPos = -1;
            if (newPos === -2) newPos = 1;
            item.setAttribute('data-pos', newPos);
        });
        resetTimer();
    }

    function startTimer() {
        autoRotateTimer = setInterval(() => {
            currentIndex = (currentIndex + 1) % items.length;
            rotate(currentIndex);
        }, 6000);
    }

    function resetTimer() {
        clearInterval(autoRotateTimer);
        startTimer();
    }

    dots.forEach((dot, i) => dot.addEventListener('click', () => rotate(i)));

    startTimer();
}
